// @ts-check
import { Flex, Separator } from 'components/base/layout-components';

import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';
import Text from 'components/base/Text';
import Icon from 'components/base/Icon';
import { LBButton } from '@linearb/buzz';

const OnPremStateWrapper = styled(Flex)`
  background-color: ${getColor('redError')};
  border: 1px solid ${getColor('redError')};
`;

const OnPremStateNotification = ({ lastOnPremisesHeartbeat, openRequest }) => {
  return (
    <OnPremStateWrapper
      items='center'
      grow='1'
      padding='small'
      minHeight='3.4rem'
      justify='space-between'
    >
      <Flex items='center' grow='1'>
        <Flex grow='1'>
          <Flex pr='small' pl='x-small'>
            <Icon name='errorOutline' size='normal' color='torchRed'></Icon>
          </Flex>
          <Text size='x-large' color='torchRed'>
            Not Connected
          </Text>
          <>
            <Separator height='2rem' margin='0 2rem' />
            <Text size='medium' color='shark' pl='x-small'>
              LinearB was unable to connect locally
            </Text>
          </>
          <>
            <Separator height='2rem' margin='0 2rem' />
            <Text size='medium' color='shark' pl='x-small'>
              <i>Last updated: {lastOnPremisesHeartbeat}</i>
            </Text>
          </>
        </Flex>
        <Flex>
          <LBButton size='lg' onClick={openRequest}>
            Contact Support
          </LBButton>
        </Flex>
      </Flex>
    </OnPremStateWrapper>
  );
};

export default OnPremStateNotification;
